import React from 'react';

// Import necessary components
import { Lightbox, PageSidebar, PageTitle } from '../../../components';

// Import icons for visual representation
import { FaCaretRight, FaCheck, FaCircleNotch } from 'react-icons/fa';

// Import useLocation to access route state
import { useLocation } from 'react-router-dom';



const DoorSingle = () => {

  // Get door details passed via router state
  const location = useLocation();
  const door = location.state;

  return (
    <>
      {/* Page Title Section */}
      <PageTitle title={door.title} page={"Door Single"} />

      <section className='door-single page-single'>

        <div className='door-info page-info'>

          {/* Door Image */}
          <div className='image'>
            <img src={door.image} alt={door.title} />
          </div>

          <div className='content'>

            {/* Door Title */}
            <h3 className='main-heading'>{door.title}</h3>

            {/* Door Description */}
            {door.paragraphs.map((paragraph, index) => (
              <p key={index} className={index === 0 ? 'important' : ''}>
                {paragraph}
              </p>
            ))}

            {/* Door Image Gallery */}
            <Lightbox images={door.gallery} />

            {/* Design and Style */}
            <div className='sub-section'>

              <h3 className='sub-heading'>Design and Style:</h3>
              <p>{door.title} is available in a variety of styles and finishes to complement your home's architecture and personal taste:</p>

              {/* List of Styles */}
              <ul>
                {door.styles.map((style, index) => {
                  return <li key={index}>
                    <div className='icon'><FaCheck /></div>
                    {style}
                  </li>
                })}
              </ul>

            </div>

            {/* Features and Benefits */}
            <div className='sub-section'>

              <h3 className='sub-heading'>Features and Benefits:</h3>
              <p>Our {door.title} offers a range of features designed to improve comfort, security, and energy efficiency in your home:</p>

              {/*Features List */}
              <ul>
                {door.features.map((feature, index) => {
                  return <li key={index}>
                    <div className='icon'><FaCaretRight /></div>
                    {feature}
                  </li>
                })}
              </ul>

            </div>

            {/* Specifications */}
            <div className='sub-section'>

              <h3 className='sub-heading'>Specifications:</h3>
              <p>A detailed overview of the size, materials, features, and performance standards of the {door.title}:</p>

              {/* Specifications List */}
              <ul>
                {door.specifications.map((specification, index) => {
                  return <li key={index}>
                    <div className='icon'><FaCircleNotch /></div>
                    {specification}
                  </li>
                })}
              </ul>

            </div>

          </div>

        </div>

        {/* Sidebar with Door details */}
        <PageSidebar
          heading={'Door'}
          details={door.details}
        />

      </section>

    </>
  );
}

export default DoorSingle;